import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";
//import logo
import logoSm from "../assets/images/cosmos.png";
import logoLight from "../assets/images/logo-light.png";
import logoDark from "../assets/images/cosmos.png";

//Import Components
import { Container } from "reactstrap";
import HorizontalLayout from "./HorizontalLayout";

const Sidebar = ({ layoutType }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [expandedItem, setExpandedItem] = useState(null);
  const user = JSON.parse(localStorage.getItem("user"));
  console.log("🚀 ~ Sidebar ~ user:", user?.organizationInfo?.displayImageLogo);

  useEffect(() => {
    var verticalOverlay = document.getElementsByClassName("vertical-overlay");
    if (verticalOverlay) {
      verticalOverlay[0].addEventListener("click", function () {
        document.body.classList.remove("vertical-sidebar-enable");
      });
    }
  }, []);

  const toggleSidebarItem = (item) => {
    if (expandedItem === item) {
      setExpandedItem(null);
    } else {
      setExpandedItem(item);
    }
  };

  const addEventListenerOnSmHoverMenu = () => {
    if (
      document.documentElement.getAttribute("data-sidebar-size") === "sm-hover"
    ) {
      document.documentElement.setAttribute(
        "data-sidebar-size",
        "sm-hover-active"
      );
    } else if (
      document.documentElement.getAttribute("data-sidebar-size") ===
      "sm-hover-active"
    ) {
      document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
    } else {
      document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
    }
  };

  const sidebarItemStyle = {
    transition: "height 0.3s ease",
    overflow: "hidden",
  };

  return (
    <React.Fragment>
      <div className="app-menu navbar-menu bg-white" >
        <div className="navbar-brand-box">
          <Link to="/Dashboard" className="logo logo-dark ">
          {/* cosmos logo */}
            {/* <span className="logo-sm color-black">
              <img src={logoSm} alt="" height="50" style={{ padding: "2px", border: "1px solid red" }} />
            </span> */}

            <span
              className="logo-lg test1"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {user?.organizationInfo?.displayImageLogo?.getCDNUrl() && (
                <img
                
                  src={user?.organizationInfo?.displayImageLogo?.getCDNUrl()}
                  alt=""
                  height="70"
                  // width={160}
                  // style={{ border:"2px solid red" }}
                />
              )}

            </span>
          </Link>

          <button
            onClick={addEventListenerOnSmHoverMenu}
            type="button"
            className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
          >
            <i className="ri-record-circle-line"></i>
          </button>
        </div>

        <SimpleBar
          id="scrollbar"
          className=" mt-1 "
          style={{ height: "95%", width: "100%" }} 
          // style={{ height: "90%", width: "100%" }} // Set the desired height and width inline

        >
          <Container fluid>
            <div id="two-column-menu"></div>
            <ul className="navbar-nav p-0 m-0 gap-0 text-start" id="navbar-nav">
              <HorizontalLayout />
            </ul>
          </Container>
        </SimpleBar>
      </div>
      <div className="vertical-overlay"></div>
    </React.Fragment>
  );
};

export default Sidebar;
